import { render, staticRenderFns } from "./LeaveOutBigScreen.vue?vue&type=template&id=cb3e8996"
import script from "./LeaveOutBigScreen.vue?vue&type=script&lang=js"
export * from "./LeaveOutBigScreen.vue?vue&type=script&lang=js"
import style0 from "./LeaveOutBigScreen.vue?vue&type=style&index=0&id=cb3e8996&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports